import { faBuilding } from '@fortawesome/pro-regular-svg-icons/faBuilding'
import { faMapMarker } from '@fortawesome/pro-regular-svg-icons/faMapMarker'
import { Box, Flex, type FlexProps, TextInput } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreUserAddress } from '@flecto/types'
import { AutocompleteAddress, CollapsibleCard, Badge, Icon } from '@flecto/ui'

import { useBusinessInfoFormContext } from './BusinessInfoFormProvider'

export function TaxAddressCard(props: FlexProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_business' })
  const form = useBusinessInfoFormContext()

  if (!form.values) {
    return null
  }

  const selectAddress = (address: CoreUserAddress) => {
    if (address.address_label) {
      form.setFieldValue(
        'legal_address.address_street',
        `${address.address_label}, ${address.address_street}`
      )
    } else {
      form.setFieldValue('legal_address.address_street', address.address_street)
    }

    form.setFieldValue('legal_address.label', 'Legal address')
    form.setFieldValue('legal_address.address_label', 'Legal address')
    form.setFieldValue('legal_address.latitude', address.latitude)
    form.setFieldValue('legal_address.longitude', address.longitude)
    form.setFieldValue('legal_address.address_city', address.address_city)
    form.setFieldValue(
      'legal_address.address_postal_code',
      address.address_postal_code
    )
    form.setFieldValue(
      'legal_address.address_country_name',
      address.address_country_name
    )
    form.setFieldValue(
      'legal_address.address_country_code',
      address.address_country_code
    )
    form.setFieldValue('legal_address.address_region', address.address_region)
  }

  return (
    <>
      <Box mb='lg'>
        <CollapsibleCard>
          <CollapsibleCard.Title>
            {t('section_tax_address.title')}
          </CollapsibleCard.Title>
          <CollapsibleCard.Description>
            {t('section_tax_address.description')}
          </CollapsibleCard.Description>
          <CollapsibleCard.Icon withCircleBackground icon={faBuilding} />
          <CollapsibleCard.RightSection>
            <Badge color='gray'>
              {form.values.vat_number ? (
                <>
                  {t('section_tax_address.vat_number')}:{' '}
                  {form.values.vat_number}
                </>
              ) : (
                t('section_tax_address.empty_vat_number')
              )}
            </Badge>
          </CollapsibleCard.RightSection>
          <CollapsibleCard.Content>
            <TextInput
              label={t('section_tax_address.vat_number')}
              mb='md'
              {...form.getInputProps('vat_number')}
            />
            <AutocompleteAddress
              mb='md'
              style={{ flex: 1 }}
              leftSection={<Icon icon={faMapMarker} />}
              countryToSearch={
                form.values.legal_address?.address_country_code || 'PT'
              }
              label={t('section_tax_address.fields.address_street_label')}
              placeholder={t(
                'section_tax_address.fields.address_street_placeholder'
              )}
              onSelectAddress={(address) => selectAddress(address)}
              {...form.getInputProps('legal_address.address_street')}
            />
            <Flex gap='md' mb='md'>
              <TextInput
                style={{ flex: 1 }}
                label={t('section_tax_address.fields.address_city_label')}
                placeholder={t(
                  'section_tax_address.fields.address_city_placeholder'
                )}
                {...form.getInputProps('legal_address.address_city')}
              />
              <TextInput
                label={t(
                  'section_tax_address.fields.address_postal_code_label'
                )}
                style={{ flex: 1 }}
                {...form.getInputProps('legal_address.address_postal_code')}
              />
            </Flex>
          </CollapsibleCard.Content>
        </CollapsibleCard>
      </Box>
    </>
  )
}
